<p-confirmDialog [appendTo]="'body'" #cd [style]="{ width: '30vw' }">
  <ng-template pTemplate="footer">
    <p-button type="button" label="No" (click)="cd.onReject()"></p-button>
    <p-button type="button" label="Yes" (click)="cd.onAccept()"></p-button>
  </ng-template>
</p-confirmDialog>
